
import React, { ComponentProps } from 'react'

import { DepotMarkerIcon } from '../MapIcons/DepotMarkerIcon'
import { IconComponent, ImgIconComponent, SvgIconComponent } from './iconComponentType'
import { LeftSidebarCollapse } from './svgs/LeftSidebarCollapse'
import { LeftSidebarExpand } from './svgs/LeftSidebarExpand'
import { rightSidebarCollapse } from './svgs/RightSidebarCollapse'
import { RightSidebarExpand } from './svgs/RightSidebarExpand'

// Mapping of iconCode to Icon Function Component
type CustomIconMapType = Record<string, {
  svg?: React.ComponentType<ComponentProps<SvgIconComponent>>
  img?: string
}>

export const CustomIconMap: CustomIconMapType = {
  'leftSidebarCollapse': {
    svg: LeftSidebarCollapse,
  },
  'leftSidebarExpand': {
    svg: LeftSidebarExpand,
  },
  'rightSidebarCollapse': {
    svg: rightSidebarCollapse,
  },
  'rightSidebarExpand': {
    svg: RightSidebarExpand,
  },
  'depot': {
    svg: DepotMarkerIcon,
  },
  'solver': {
    img: '/images/solver.png',
  },
} as const

export type IconCodeType = keyof typeof CustomIconMap

export type CustomIconProps = React.ComponentProps<IconComponent> & {
  iconCode: IconCodeType
}

export const CustomIcon: React.FC<CustomIconProps> = ({ iconCode, svg, ...props }) => {
  const Icon = CustomIconMap[iconCode]

  if (Icon?.svg && (!Icon?.img || svg)) {
    return (
      <Icon.svg {...props as ComponentProps<typeof Icon.svg>} />
    )
  }

  return Icon?.img ? (
    <img src={Icon.img} alt="" {...props as ComponentProps<ImgIconComponent>} />
  ) : null
}
